import "jquery/dist/jquery.min.js";
import Axios from "axios";
import $ from "jquery";
import EditForm from "@/pages/assets/editasset/editasset.vue";
import MarkAsBeingRepaired from "@/pages/vehicles/markasbeingrepaired/markasbeingrepaired.vue";
import VueGallery from "vue-gallery";
import DriverProfilePicture from "@/pages/drivers/driverprofilepicture/driverprofilepicture";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import VehicleChecks from "@/pages/vehicles/vehiclechecks/vehiclechecks.vue";
import DeleteImage from '@/pages/operations/deleteimage/deleteimage';
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
import VehicleDocuments from "@/pages/vehicles/vehicledocuments/vehicledocuments.vue";
import VehicleServiceHistory from "@/pages/vehicles/vehicleservicehistory/vehicleservicehistory.vue";
import QrCode from "@/pages/assets/qrcode/qrcode.vue";

import Swiper, {navigation} from 'swiper';

var moment = require("moment");
export default {
  components: {
    EditForm,
    MarkAsBeingRepaired,
    VueGallery,
    DriverProfilePicture,
    UpcomingEvent,
    VehicleChecks,
    DeleteImage,
    DocumentPopup,
    VehicleDocuments,
    VehicleServiceHistory,
    QrCode
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
    }
  },
  data() {
    return {
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      CompanyData:"",
      PopupLoader: false,
      ShowLoader: false,
      submitted: false,
      AssetId: 0,
      editForm: false,
      SaveData: false,
      ShowDocuments:false,
      fromDate: "",
      toDate: "",
      vrm: "",
      VehicleNotes: "",
      VehicleChecks: [],
      NewAsset: {
        additional_photos:[],
        assignments:[],
      },
      AssginVehicle: { asset_id: 0, vehicle_id: 0 },
      file: "",
      SearchData: false,
      gindex: 1,
      AccountPermissions:[],
      ShowAssetAssignVehicle:false,
      ShowAssetEdit:false,
      ShowAssetDelete:false,
      ShowUrgentTask:false,
      ShowVehicleChecks:false,
      DocumentPopupSubCategory:false,
      DocumentPopupCategory:"",
      FleetSubscription:[],
    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
      );
      this.AccountPermissions = AccountPermissions;

      this.FleetSubscription = JSON.parse(
        localStorage.getItem("FleetSubscription")
      );
      var FleetSubscriptionModules = JSON.parse(
        this.FleetSubscription.fleet_modules
      );
      if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Assets || !AccountPermissions.Assets.enable)){
      this.$router.push('/');
    }

    if (this.AccountPermissions && 
      this.AccountPermissions.Assets &&
      this.AccountPermissions.Assets.enable) {
      if ( this.AccountPermissions.Assets.edit) {
        this.ShowAssetEdit = true;
      }
      if ( this.AccountPermissions.Assets.delete) {
        this.ShowAssetDelete = true;
      }
    }
    
    if (AccountPermissions && 
      AccountPermissions['Vehicle Checks'] &&
      AccountPermissions['Vehicle Checks']['enable']) {
        this.ShowVehicleChecks = true;
        if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
          this.ShowUrgentTask = true;
        }
    }

    if (this.AccountPermissions && 
      this.AccountPermissions.Documents &&
      this.AccountPermissions.Documents.enable) {
        this.ShowDocuments = true;
      }

    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowAssetEdit = true;
      this.ShowAssetDelete = true;
      this.ShowUrgentTask = true;
      this.ShowVehicleChecks = true;
      this.ShowDocuments = true;
    }

    this.CompanyData = JSON.parse(localStorage.getItem("Company")); 
    this.AssetId = this.$route.params.AssetId;
    setTimeout(() => {
      this.GetAssetDetail();
    }, 1000);
  },

  methods: {

    AddDocument(type = "") {
      var heading = '';
      if(type == 'service'){
        heading = 'Service';
      }
      var category = "vehicle";
      this.NewDocument={};
      this.DocumentPopupCategory = category;
      this.DocumentPopupSubCategory = type;
      this.$refs.popup.loadPopupModal(type,heading);
    },
    
    LoadProfileData(){
		this.GetAssetDetail();
	},
    EditDocument(document) {
      this.$refs.popup.loadEditData(document);
    },
    DeleteDocument(document_id) {
      this.$refs.popup.DeleteDocumentData(document_id);
    },
    LoadHistory() {
      this.$refs.asset_history.GetVehicleServices();
      this.$refs.asset_document.GetDocumentList();
    },
    GetAssetDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Assets.Get, {
        token: localStorage.getItem("token"),
        Assets_id: this.AssetId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response.data.success) {
          this.NewAsset = Response.data.record;
          if(this.NewAsset.additional_photos != null && this.NewAsset.additional_photos != "" && this.NewAsset.additional_photos.length > 0){
            this.NewAsset.additional_photos = JSON.parse(this.NewAsset.additional_photos);
          } else{
            this.NewAsset.additional_photos = [];
          }
          
          setTimeout(() => {
						new Swiper('.swiper', {
							// Optional parameters
							direction: 'horizontal',
							loop: this.vehicleLoop,
							// Navigation arrows
							navigation: {
							  nextEl: '.swiper-button-next',
							  prevEl: '.swiper-button-prev',
							},
						  });
					}, 1000);

        }else{
          this.$router.push("/error-404");
        }
      });
    },
    DeleteAsset(asset_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to delete this Asset?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Assets.Delete, {
              token: localStorage.getItem("token"),
              id: asset_id,
            }).then((Response) => {
              if (Response.data.success == true) {
                this.$router.push("/assets/list");
                this.$swal
                  .fire("Asset Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response.data.message, "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    
  },
};
